export default class {
  constructor(selector) {
    this.selector = selector;
    this.el = document.querySelector(this.selector);
    if (!this.el) return;

    this.buttonList = this.el.querySelectorAll('a');
    this.buttonListCount = this.buttonList.length;
    this.maxColumn = 3; // 最大列数

    this._setButtonCount = this._setButtonCount.bind(this);
    this._setButtonCount();
  }

  //  js-contact-buttonsのaタグの個数を数えて、css変数に渡す
  _setButtonCount() {
    const buttonCount = (this.buttonListCount <= this.maxColumn) ? this.buttonListCount : this.maxColumn;

    this.el.style.setProperty('--button-count', buttonCount);
  }
}